import React, { useEffect } from "react";
import LandingPage from "./components/SapieducaIA/LandingPage";
import LegalPage from "./pages/LegalPage";
import "./index.css";

const App = () => {
  const rawPath = window.location.pathname;
  const path = rawPath.length > 1 && rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;

  useEffect(() => {
    if (path === "/" || path === "") {
      window.location.replace("https://app.sapieduca.com.br");
    }
  }, [path]);

  if (path === "/" || path === "") {
    return null;
  }

  if (path === "/termos") {
    return <LegalPage type="terms" />;
  }

  if (path === "/privacidade") {
    return <LegalPage type="privacy" />;
  }

  if (path === "/lp") {
    return <LandingPage />;
  }

  return <LandingPage />;
};

export default App;
